module.exports = __webpack_public_path__ + "img/horizontal_4_4_r_pp1_8023.3152c557.png";